export const UtilsJson = {
  baseUrl: "https://18.138.58.50:8000/"
};
